<template>
    <form-row title="Who Pays for the Survey?" :no_border="true" class="mt-8">
        <buyer-seller-split
            field="survey_who_pays"
            :value="commercial.survey_who_pays"
            :read_only="read_only"
        />
    </form-row>
</template>

<script>
import BuyerSellerSplit from '../../buyer-seller-split.vue';

export default {
    components: {
        BuyerSellerSplit,
    },

    props: {
        commercial: { default: () => ({}) },
        read_only: { default: false },
    },
}
</script>
